module.exports = __webpack_public_path__ + "img/Logo-Inflow-Hor-BB@2x.fc22d49e.png";